import {ProgressAnimation} from '@components/helpers/ProgressAnimation';
import {ProgressImageAnimation} from '@components/helpers/ProgressImageAnimation';
import {MediaQuery} from '@services/MediaQuery';

export class ProgressAnimationItems {
  mq = MediaQuery.create()
  images: HTMLDivElement[] = []
  sublines: HTMLDivElement[] = []
  ids: HTMLDivElement[] = []
  titles: HTMLDivElement[] = []
  links: HTMLDivElement[] = []
  circles: HTMLDivElement[] = []

  imagesAnimation = new ProgressImageAnimation()
  sublinesAnimation = new ProgressAnimation()
  idsAnimation = new ProgressAnimation()
  titlesAnimation = new ProgressAnimation()
  linksAnimation = new ProgressAnimation()
  circlesAnimation = new ProgressAnimation()

  seek(per: number) {
    this.imagesAnimation.seek(per)
    this.sublinesAnimation.seek(per)
    this.idsAnimation.seek(per)
    this.titlesAnimation.seek(per)
    this.linksAnimation.seek(per)
    this.circlesAnimation.seek(per)
  }

  init(element: HTMLDivElement) {
    if (this.mq.isDesktop()) {
      this.images.map((image, index) => {
        if (index !== 0) {
          image.classList.remove('js-image')
        }
      })
    }
    this.images = [...element.querySelectorAll('.js-progress-animation-image .a-image')] as HTMLDivElement[]
    this.sublines = [...element.querySelectorAll('.js-progress-animation-subline')] as HTMLDivElement[]
    this.ids = [...element.querySelectorAll('.js-progress-animation-id')] as HTMLDivElement[]
    this.titles = [...element.querySelectorAll('.js-progress-animation-title')] as HTMLDivElement[]
    this.links = [...element.querySelectorAll('.js-progress-animation-link')] as HTMLDivElement[]
    this.circles = [...element.querySelectorAll('.js-progress-animation-circles')] as HTMLDivElement[]

    this.imagesAnimation.init(this.images, 0)
    this.idsAnimation.init(this.ids, 0)
    this.sublinesAnimation.init(this.sublines, 1000)
    this.titlesAnimation.init(this.titles, 1000)
    this.linksAnimation.init(this.links, 2000)
    this.circlesAnimation.init(this.circles, 2000)

    if (this.mq.isDesktop()) {
      element.style.height = `${this.images.length * 100}vh`;
    }
  }

}
